import React, { useCallback } from 'react';
import { useDraft2 } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useSubmitter } from '../../platform/Hook';
import { Button, Input, Prompt } from '../../ui';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { workspaceCreate } from './WorkspaceCommands';

export const createTeamPopup = () => ({ ui: CreateTeamPopup });

export const CreateTeamPopup: LFC<PopupProps> = ({ action, dismiss }) => {

    const dispatch = useResolve(CommandDispatcher);

    const { draft, patchDraft } = useDraft2({
        label: '',
        desc: '',
        makePublic: false
    });

    const invalid = !draft.label.trim();

    const [onSubmit, working, result] = useSubmitter(async () => {
        action(await dispatch(workspaceCreate, [draft.label, draft.desc, true, draft.makePublic]));
    }, [draft]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onSubmit();
    }, [invalid, onSubmit]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Create Team</Popup.Title>
            <Popup.Content>
                <Copy>
                    Please enter the name for this team:
                </Copy>
                <Input
                    placeholder="e.g. Product Team"
                    autoFocus
                    value={draft.label}
                    onChange={x => patchDraft({ label: x })}
                />
                <Spacer f={1} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={onSubmit}>
                    {working ? 'Creating...' : 'Create'}
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
